import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MeetingsStatisticsAPI from '../../../api/MeetingsStatisticsAPI';
import { Badge } from '../../../components/Badge/Badge';

type Props = { timeRange: { start: string; end: string } };

function NoShowsRatioCard({ timeRange }: Props) {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);
  const [noShows, setNoShows] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await MeetingsStatisticsAPI.getNoShowsRatio({ startTime: timeRange.start, endTime: timeRange.end });
        setTotal(res.data?.denominator || 0);
        setNoShows(res.data?.numerator || 0);
      } catch (e) {
        setTotal(0);
        setNoShows(0);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end]);

  const percentage = total > 0 ? ((noShows / total) * 100) : 0;

  return (
    <div className="space-y-3">
      <div className="flex items-baseline justify-between">
        <span className="text-2xl font-bold text-foreground">{percentage.toFixed(2).replace(/\.?0+$/, '')}%</span>
        <Badge variant={percentage > 0 ? 'destructive' : 'secondary'} className="text-xs">
          {t('stats.noshow') || 'No-show'}
        </Badge>
      </div>
      <p className="text-sm text-muted-foreground">
        {t('stats.noshow_vs_total', { noShows, total }) || `${noShows} no-shows of ${total} meetings`}
      </p>
    </div>
  );
}

export default NoShowsRatioCard;


